import React from 'react';

const StaticDisplyALevelRequirements = () => {

    return (
        <div style={{
            paddingBottom: 10, width: '90%',
            marginLeft: '4%'
        }}>
            <div>
                <span>
                    ●
            </span>
                <span style={{ fontSize: 20, marginLeft: 20 }}>
                    To enter a university in UK, the minimum requirement is five GCE passes,
                    two of which must be at the Advanced Level but as those with more than
                    minimum qualifications have a greater chance of admission,
                    we, at the Universal College Lahore, expect a student to take a
                    minimum of three and a maximum of four subjects.
            </span>
            </div>
            <br />
            <div>
                <span>
                    ●
            </span>
                <span style={{ fontSize: 20, marginLeft: 20 }}>
                    Those wishing to study medicine should opt Physics, Chemistry and Biology while
                    those aiming at engineering are expected to opt Physics, Chemistry and Mathematics.
                    Science subjects can only be opted at Universal College Lahore if a student has
                    passed the same subjects at the ‘O’ level with good grades. For admission in
                    under-graduate courses in humanities / social sciences, rules regarding the
                    choice of subjects are not so strict.
            </span>
            </div>
        </div >
    );
}

export default StaticDisplyALevelRequirements;